export const SchedulerServiceBaseUrl = 'https://api.scheduler.warnerbros.com';   
export const OKTA_CLIENT_ID = "0oax9cnqh8hFra1o00x7";
export const OKTA_ISSUER_URL = "https://sso.wbd.com/oauth2/default";
export const OKTA_REDIRECT_URL = window.location.origin + '/callback';
export const OKTA_URL = "https://sso.wbd.com";
export const IDLE_TIMEOUT = "60";
export const IDLE_WARN_TIMEOUT = "30";
export const FULL_CALENDAR_KEY="0273663870-fcs-1663942375"
